import React from "react";
import "../assets/scss/components/sidebar.scss";
import "../assets/scss/components/company-logo.scss";
import MainNav from "./MainNav";
import Logo from "./Logo";
import { useThemeContext } from "../contexts/ThemeContext";

const Sidebar = (props) => {
  const { theme } = useThemeContext();
  return (
    <div className="sidebar">
      <div className="sidebar-top">
        <div className="company-logo">
          <Logo
            className="horizontal-logo"
            src={theme.logo}
            alt="sidebar-logo"
          />
        </div>
      </div>
      <div className="sidebar-main">
        <MainNav />
      </div>
    </div>
  );
};

export default Sidebar;
